import { Box } from '@betty/moonlight';
import { Page } from '@betty/navigation';
import AboutUsSection from './components/AboutUsSection/AboutUsSection';
import TopBannerSection from './components/TopBannerSection/TopBannerSection';
import TrustPilotSection from './components/TrustPilotSection/TrustPilotSection';
import WhyBettySection from './components/WhyBettySection/WhyBettySection';
import BigWinsSection from './components/BigWinsSection/BigWinsSection';
import EarnRewardsSection from './components/EarnRewardsSection/EarnRewardsSection';
import ProvidersSection from './components/ProvidersSection/ProvidersSection';
import LandingCarouselSection from './components/LandingCarouselSection/LandingCarouselSection';
import PromosSection from './components/PromosSection/PromosSection';
import FAQsSection from './components/FAQsSection/FAQsSection';
import DownloadAppSection from './components/DownloadAppSection/DownloadAppSection';
import StickyPromoBanner from './components/TopBannerSection/MainLabel/StickyPromoBanner/StickyPromoBanner';

function LandingPage() {
  return (
    <Page>
      <StickyPromoBanner />
      <Box
        flexDirection="column"
        width="100%"
        gap={{
          desktop: 'space-2000',
          tablet: 'space-2000',
          mobile: 'space-800',
        }}
        backgroundColor="screenBackground"
        paddingBottom="space-2000"
      >
        <TopBannerSection />
        <Box
          paddingHorizontal={{
            desktop: 'space-600',
            tablet: 'space-400',
            mobile: 'space-400',
          }}
          flexDirection="column"
          width="100%"
          gap="space-2000"
        >
          <TrustPilotSection />
          <WhyBettySection />
          <BigWinsSection />
          <EarnRewardsSection />
          <AboutUsSection />
          <ProvidersSection />
          <LandingCarouselSection />
          <PromosSection />
          <EarnRewardsSection />
          <FAQsSection />
          <DownloadAppSection />
        </Box>
      </Box>
    </Page>
  );
}

export default LandingPage;
